// extracted by mini-css-extract-plugin
export var cardNumber = "AustralianDriverLicense-module--cardNumber--64395";